<template>
  <div class="page-section">
    <h1 class="info-title white">
      Free up <b>extra money</b>
    </h1>
    <p class="section-subtitle">
      If you implement these tips, you could potentially save an extra <b>£{{ numberToHumanReadable(totalSavings) }}
        per month.</b>
    </p>
    <div
      v-if="isDataMissing"
      class="connect-another-subtitle"
    >
      We don't have enough data to display your Saving tips.
      <b @click="handleConnectAccountsClick">connect an active account</b>
      to get the full picture.
    </div>
    <horizontal-scroll>
      <div v-for="(tip, index) in displayTips" :key="index" class="card" :class="{ 'disabled': isDataMissing }">
        <div class="tip-number">
          {{ index + 1 }}
        </div>
        <div class="tip-text">
          {{ tip.text }}
        </div>
      </div>
    </horizontal-scroll>
    <div v-if="showBackground" class="light-blue-background-color" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import HorizontalScroll from '../../Common/HorizontalScroll.vue';
import { numberToHumanReadable } from '../../../utils/miscUtils';

const props = defineProps({
  tips: {
    type: Array,
    required: true,
  },
  totalSavings: {
    type: Number,
    required: true,
  },
  isDataMissing: {
    type: Boolean,
    required: true,
  },
  showBackground: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['connectAccountsClick']);

const displayTips = computed(() => {
  if (props.isDataMissing) {
    return [
      { text: 'Connect another account to get these saving tips' },
      { text: 'Connect another account to get these saving tips' },
    ];
  }

  return props.tips;
});

const handleConnectAccountsClick = () => {
  emit('connectAccountsClick');
};
</script>

<style lang="scss" scoped>
@import '../../../scss/riseup-vars';

.info-title {
  font-size: 36px;
  font-family: 'SalaryFinance';
  padding-top: 40px;
  padding-right: 25px;
  margin-bottom: 20px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
  line-height: 1;
}

.white {
  color: #FFFFFF;
}

.info-title b {
  font-weight: 700;
}

.section-subtitle {
  font-size: 17px;
  font-family: 'SalaryFinance';
  margin-top: 25px;
  margin-bottom: 40px;
  text-align: left;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
}

.connect-another-subtitle {
  font-size: 14px;
  font-family: 'SalaryFinance';
  margin-bottom: 10px;
  margin-top: 10px;
  background-color: #FFDC73;
  color: #002579;
  text-align: center;
  padding: 20px;
  border-radius: 16px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
}

.connect-another-subtitle b {
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

.card {
  z-index: 1;
  flex: 0 0 300px;
  background-color: white;
  border-radius: 25px;
  padding: 28px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  min-height: 330px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.card.disabled::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(44, 74, 144, 0.85);
  box-shadow: 0px 16px 46.4px 0px #00000010 !important;
  border-radius: 25px;
  z-index: 2;
}

.tip-number {
  width: 36px;
  height: 36px;
  background-color: #FFCE00;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  font-weight: bold;
  color: #205441;
  margin-bottom: 20px;
}

.tip-text {
  font-size: 17px;
  color: #205441;
  line-height: 1.5;
  flex: 1;
  width: 100%;
  white-space: normal;
  margin-bottom: 30px;
}

.light-blue-background-color {
  background-color: #EEF2F8;
  height: 100px;
  z-index: 0;
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>
